import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export interface IFormulaireProps {
    valueModuleDroit: any;
    setValueModuleDroit: any;
}

const Formulaire = (props: IFormulaireProps) => {


    const {
        valueModuleDroit,
        setValueModuleDroit
    } = props



    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Module"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueModuleDroit"
                        value={valueModuleDroit}
                        onChange={(e) => setValueModuleDroit(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}

export default Formulaire;
